var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from "bignumber.js";
import { NotEnoughBalance, RecipientRequired, InvalidAddress, InvalidAddressBecauseDestinationIsAlsoSource, AmountRequired, NotEnoughBalanceBecauseDestinationNotCreated, FeeNotLoaded, } from "@ledgerhq/errors";
import { formatCurrencyUnit } from "@ledgerhq/coin-framework/currencies/index";
import { PolkadotUnauthorizedOperation, PolkadotElectionClosed, PolkadotNotValidator, PolkadotNoUnlockedBalance, PolkadotNoNominations, PolkadotAllFundsWarning, PolkadotBondMinimumAmount, PolkadotBondMinimumAmountWarning, PolkadotMaxUnbonding, PolkadotValidatorsRequired, PolkadotDoMaxSendInstead, } from "./errors";
import { verifyValidatorAddresses } from "./api";
import { EXISTENTIAL_DEPOSIT, FEES_SAFETY_BUFFER, isFirstBond, isController, isStash, hasLockedBalance, hasMaxUnlockings, calculateAmount, getMinimumAmountToBond, getMinimumBalance, EXISTENTIAL_DEPOSIT_RECOMMENDED_MARGIN, } from "./logic";
import { isValidAddress } from "./address";
import { getCurrentPolkadotPreloadData } from "./preload";
import { isControllerAddress, isNewAccount, isElectionClosed } from "./cache";
import { loadPolkadotCrypto } from "./polkadot-crypto";
// Should try to refacto
var getSendTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, estimatedFees, amount, totalSpent, minimumBalanceExistential, leftover, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                errors = {};
                warnings = {};
                if (!t.fees) {
                    errors.fees = new FeeNotLoaded();
                }
                if (!t.recipient) {
                    errors.recipient = new RecipientRequired("");
                }
                else if (a.freshAddress === t.recipient) {
                    errors.recipient = new InvalidAddressBecauseDestinationIsAlsoSource();
                }
                else if (!isValidAddress(t.recipient)) {
                    errors.recipient = new InvalidAddress("", {
                        currencyName: a.currency.name
                    });
                }
                estimatedFees = t.fees || new BigNumber(0);
                amount = calculateAmount({
                    a: a,
                    t: t
                });
                totalSpent = amount.plus(estimatedFees);
                if (amount.lte(0) && !t.useAllAmount) {
                    errors.amount = new AmountRequired();
                }
                minimumBalanceExistential = getMinimumBalance(a);
                leftover = a.spendableBalance.minus(totalSpent);
                if (minimumBalanceExistential.gt(0) &&
                    leftover.lt(minimumBalanceExistential) &&
                    leftover.gt(0)) {
                    errors.amount = new PolkadotDoMaxSendInstead("", {
                        minimumBalance: formatCurrencyUnit(a.currency.units[0], EXISTENTIAL_DEPOSIT, { showCode: true })
                    });
                }
                else if (!errors.amount &&
                    !t.useAllAmount &&
                    a.spendableBalance.lte(EXISTENTIAL_DEPOSIT.plus(EXISTENTIAL_DEPOSIT_RECOMMENDED_MARGIN))) {
                    errors.amount = new NotEnoughBalance();
                }
                else if (totalSpent.gt(a.spendableBalance)) {
                    errors.amount = new NotEnoughBalance();
                }
                if (!errors.amount &&
                    ((_b = a.polkadotResources) === null || _b === void 0 ? void 0 : _b.lockedBalance.gt(0)) &&
                    (t.useAllAmount ||
                        a.spendableBalance.minus(totalSpent).lt(FEES_SAFETY_BUFFER))) {
                    warnings.amount = new PolkadotAllFundsWarning();
                }
                _a = !errors.recipient &&
                    amount.lt(EXISTENTIAL_DEPOSIT);
                if (!_a) return [3 /*break*/, 2];
                return [4 /*yield*/, isNewAccount(t.recipient)];
            case 1:
                _a = (_c.sent());
                _c.label = 2;
            case 2:
                if (_a) {
                    errors.amount = new NotEnoughBalanceBecauseDestinationNotCreated("", {
                        minimalAmount: formatCurrencyUnit(a.currency.units[0], EXISTENTIAL_DEPOSIT, {
                            showCode: true
                        })
                    });
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount.lt(0) ? new BigNumber(0) : amount,
                        totalSpent: totalSpent,
                        family: t.family
                    })];
        }
    });
}); };
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, preloaded, staking, validators, minimumBondBalance, _a, _b, amount, unlockingBalance, unlockedBalance, currentBonded, minimumAmountToBond, _c, notValidators, notValidators, estimatedFees, totalSpent;
    var _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0: return [4 /*yield*/, loadPolkadotCrypto()];
            case 1:
                _k.sent();
                errors = {};
                warnings = {};
                preloaded = getCurrentPolkadotPreloadData();
                staking = preloaded.staking, validators = preloaded.validators;
                minimumBondBalance = new BigNumber(preloaded.minimumBondBalance);
                if (!(t.mode === "send")) return [3 /*break*/, 3];
                return [4 /*yield*/, getSendTransactionStatus(a, t)];
            case 2: return [2 /*return*/, _k.sent()];
            case 3:
                _a = (staking && !staking.electionClosed);
                if (_a) return [3 /*break*/, 6];
                _b = !staking;
                if (!_b) return [3 /*break*/, 5];
                return [4 /*yield*/, !isElectionClosed()];
            case 4:
                _b = (_k.sent());
                _k.label = 5;
            case 5:
                _a = (_b); // Fallback
                _k.label = 6;
            case 6:
                if (_a) {
                    errors.staking = new PolkadotElectionClosed();
                }
                amount = calculateAmount({
                    a: a,
                    t: t
                });
                unlockingBalance = ((_d = a.polkadotResources) === null || _d === void 0 ? void 0 : _d.unlockingBalance) || new BigNumber(0);
                unlockedBalance = ((_e = a.polkadotResources) === null || _e === void 0 ? void 0 : _e.unlockedBalance) || new BigNumber(0);
                currentBonded = ((_f = a.polkadotResources) === null || _f === void 0 ? void 0 : _f.lockedBalance.minus(unlockingBalance)) ||
                    new BigNumber(0);
                minimumAmountToBond = getMinimumAmountToBond(a, minimumBondBalance);
                _c = t.mode;
                switch (_c) {
                    case "bond": return [3 /*break*/, 7];
                    case "unbond": return [3 /*break*/, 12];
                    case "rebond": return [3 /*break*/, 13];
                    case "withdrawUnbonded": return [3 /*break*/, 14];
                    case "nominate": return [3 /*break*/, 15];
                    case "chill": return [3 /*break*/, 21];
                    case "setController": return [3 /*break*/, 22];
                }
                return [3 /*break*/, 23];
            case 7:
                if (amount.lt(minimumAmountToBond)) {
                    errors.amount = new PolkadotBondMinimumAmount("", {
                        minimumBondAmount: formatCurrencyUnit(a.currency.units[0], minimumAmountToBond, { showCode: true })
                    });
                }
                if (!isFirstBond(a)) return [3 /*break*/, 11];
                if (!!t.recipient) return [3 /*break*/, 8];
                errors.recipient = new RecipientRequired("");
                return [3 /*break*/, 11];
            case 8:
                if (!!isValidAddress(t.recipient)) return [3 /*break*/, 9];
                errors.recipient = new InvalidAddress("", {
                    currencyName: a.currency.name
                });
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, isControllerAddress(t.recipient)];
            case 10:
                if (_k.sent()) {
                    errors.recipient = new PolkadotUnauthorizedOperation("Recipient is already a controller");
                }
                _k.label = 11;
            case 11: return [3 /*break*/, 23];
            case 12:
                if (!isController(a) || !hasLockedBalance(a)) {
                    errors.staking = new PolkadotUnauthorizedOperation();
                }
                if (hasMaxUnlockings(a)) {
                    errors.unbondings = new PolkadotMaxUnbonding();
                }
                if (amount.lte(0)) {
                    errors.amount = new AmountRequired();
                }
                else if (amount.gt(currentBonded.minus(minimumBondBalance)) &&
                    amount.lt(currentBonded)) {
                    warnings.amount = new PolkadotBondMinimumAmountWarning("", {
                        minimumBondBalance: formatCurrencyUnit(a.currency.units[0], minimumBondBalance, { showCode: true })
                    });
                }
                else if (amount.gt(currentBonded)) {
                    errors.amount = new NotEnoughBalance();
                }
                return [3 /*break*/, 23];
            case 13:
                if (!isController(a)) {
                    errors.staking = new PolkadotUnauthorizedOperation();
                }
                if (amount.lte(0)) {
                    errors.amount = new AmountRequired();
                }
                else if (amount.gt(unlockingBalance)) {
                    errors.amount = new NotEnoughBalance();
                }
                else if (amount.lt(minimumAmountToBond)) {
                    warnings.amount = new PolkadotBondMinimumAmountWarning("", {
                        minimumBondBalance: formatCurrencyUnit(a.currency.units[0], minimumBondBalance, { showCode: true })
                    });
                }
                return [3 /*break*/, 23];
            case 14:
                if (!isController(a)) {
                    errors.staking = new PolkadotUnauthorizedOperation();
                }
                if (unlockedBalance.lte(0)) {
                    errors.amount = new PolkadotNoUnlockedBalance();
                }
                return [3 /*break*/, 23];
            case 15:
                if (!!isController(a)) return [3 /*break*/, 16];
                errors.staking = new PolkadotUnauthorizedOperation();
                return [3 /*break*/, 20];
            case 16:
                if (!(!t.validators || ((_g = t.validators) === null || _g === void 0 ? void 0 : _g.length) === 0)) return [3 /*break*/, 17];
                errors.staking = new PolkadotValidatorsRequired();
                return [3 /*break*/, 20];
            case 17:
                if (!(validators && validators.length)) return [3 /*break*/, 18];
                notValidators = (_h = t.validators) === null || _h === void 0 ? void 0 : _h.filter(function (address) { return !validators.find(function (v) { return v.address === address; }); });
                if (notValidators && notValidators.length) {
                    errors.staking = new PolkadotNotValidator(undefined, {
                        validators: notValidators
                    });
                }
                return [3 /*break*/, 20];
            case 18: return [4 /*yield*/, verifyValidatorAddresses(t.validators || [])];
            case 19:
                notValidators = _k.sent();
                if (notValidators.length) {
                    errors.staking = new PolkadotNotValidator(undefined, {
                        validators: notValidators
                    });
                    return [3 /*break*/, 23];
                }
                _k.label = 20;
            case 20: return [3 /*break*/, 23];
            case 21:
                if (!isController(a)) {
                    errors.staking = new PolkadotUnauthorizedOperation();
                }
                else if (!((_j = a.polkadotResources) === null || _j === void 0 ? void 0 : _j.nominations)) {
                    errors.staking = new PolkadotNoNominations();
                }
                return [3 /*break*/, 23];
            case 22:
                if (!isStash(a)) {
                    errors.staking = new PolkadotUnauthorizedOperation();
                }
                return [3 /*break*/, 23];
            case 23:
                estimatedFees = t.fees || new BigNumber(0);
                totalSpent = t.mode === "bond" ? amount.plus(estimatedFees) : estimatedFees;
                if (t.mode === "bond" || t.mode === "unbond" || t.mode === "rebond") {
                    if (amount.lte(0)) {
                        errors.amount = new AmountRequired();
                    }
                }
                if (t.mode === "bond" &&
                    a.spendableBalance.minus(totalSpent).lt(FEES_SAFETY_BUFFER)) {
                    errors.amount = new NotEnoughBalance();
                }
                if (totalSpent.gt(a.spendableBalance)) {
                    errors.amount = new NotEnoughBalance();
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount.lt(0) ? new BigNumber(0) : amount,
                        totalSpent: totalSpent
                    })];
        }
    });
}); };
export default getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map